export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0713_FC1_1198_tn.7d56f6fa.jpg";